import React from 'react';

const AppTermsPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-white font-sans text-gray-800">
            {/* Simple Header for Branding */}
            <div className="bg-white shadow-sm border-b border-gray-100 py-6 sticky top-0 z-10">
                <div className="container mx-auto px-4 flex justify-center items-center">
                    <img src="/images/logo.png" alt="MarryCenter Logo" className="h-10 w-auto mr-3" />
                    <span className="text-3xl font-bold bg-gradient-to-r from-romantic-600 to-primary-600 bg-clip-text text-transparent" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
                        MarryCenter
                    </span>
                </div>
            </div>

            <div className="flex-grow py-8 bg-gray-50">
                <div className="w-full max-w-[95%] mx-auto bg-white p-8 md:p-12 rounded-xl shadow-sm">
                    <h1 className="text-4xl md:text-5xl font-bold mb-10 text-gray-900 border-b pb-6">Terms of Service</h1>

                    <div className="space-y-8 text-lg md:text-xl leading-relaxed text-gray-700">
                        <section>
                            <p className="mb-6 font-semibold">Last Updated: February 01, 2026</p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">1. Acceptance of Terms</h2>
                            <p className="mb-6">
                                Welcome to Marry Center app and MarryCenter.com ("the App, Website," "we," "us," or "our"). By accessing, browsing, or using the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you do not agree to these Terms, you must not use this Website.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">2. Eligibility</h2>
                            <ul className="list-disc pl-8 space-y-4 mb-8">
                                <li>You must be at least 18 years of age to use this App or Website.</li>
                                <li>You must be legally eligible to enter into a matrimonial alliance under the laws of the country you reside in.</li>
                                <li>By registering, you represent and warrant that you are seeking a life partner for yourself or a blood relative (like a sibling or child) and not for any other purpose.</li>
                                <li>If you are registering on behalf of another person, you confirm you have their valid consent and that they are at least 18 years of age.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">3. User Account and Registration</h2>
                            <ul className="list-disc pl-8 space-y-4 mb-8">
                                <li>You must provide accurate, current, and complete information during the registration process.</li>
                                <li>You are solely responsible for maintaining the confidentiality of your account and password and for all activities that occur under your account.</li>
                                <li>You agree to notify us immediately of any unauthorized use of your account or any other breach of security.</li>
                                <li>We reserve the right to suspend or terminate your account if any information provided is inaccurate, false, or misleading.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">4. User Conduct and Prohibited Activities</h2>
                            <p className="mb-4">You agree not to use the Website to:</p>
                            <ul className="list-disc pl-8 space-y-4 mb-8">
                                <li>Harass, abuse, threaten, or intimidate any other user.</li>
                                <li>Post any content that is defamatory, obscene, pornographic, racist, hateful, or otherwise objectionable.</li>
                                <li>Engage in any fraudulent, deceptive, or illegal activity.</li>
                                <li>Post copyrighted material without the express permission of the owner.</li>
                                <li>Use the service for any purpose other than seeking a matrimonial partner (e.g., prostitution, escort services, business promotions).</li>
                                <li>Post profiles for or on behalf of any other person without their explicit consent.</li>
                                <li>Transmit any viruses, worms, or any code of a destructive nature.</li>
                                <li>Attempt to gain unauthorized access to any part of the Website or other user accounts.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">5. Reporting and Enforcement</h2>
                            <p className="mb-6">
                                Users may report violations of these Terms through the in-app reporting tools. We reserve the right to investigate, remove content, and take appropriate action, including suspension or termination of accounts, in accordance with our Safety Standards & Guidelines.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">6. Profile Content and Ownership</h2>
                            <ul className="list-disc pl-8 space-y-4 mb-8">
                                <li>You are solely responsible for the content (photos, bio, personal details) you post on the Website.</li>
                                <li>By posting content, you grant MarryCenter.com a worldwide, non-exclusive, royalty-free license to use, display, and reproduce such content solely for the purpose of operating the Website and providing our services to you.</li>
                                <li>You confirm that you own or have the necessary rights to all content you post and that it does not violate any third-party rights.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">7. Privacy</h2>
                            <p className="mb-6">
                                Your privacy is important to us. We do not routinely read private messages, except where required by law or in response to user reports, as outlined in our Privacy Policy.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">8. Third-Party Links and Content</h2>
                            <p className="mb-6">
                                The Website may contain links to third-party websites. We are not responsible for the content, accuracy, or opinions expressed on such websites, and we do not investigate, monitor, or check them for accuracy or completeness.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">9. Disclaimer of Warranties</h2>
                            <p className="mb-6">
                                THE WEBSITE AND ITS SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. WE MAKE NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. WE DO NOT GUARANTEE THE ACCURACY, COMPLETENESS, OR USEFULNESS OF ANY PROFILES OR COMMUNICATIONS.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">10. Limitation of Liability</h2>
                            <p className="mb-6">
                                TO THE FULLEST EXTENT PERMITTED BY LAW, MARRYCENTER.COM, ITS OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE WEBSITE. OUR TOTAL LIABILITY TO YOU FOR ANY CLAIM SHALL NOT EXCEED THE AMOUNT YOU HAVE PAID TO US IN THE LAST SIX MONTHS.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">11. Indemnification</h2>
                            <p className="mb-6">
                                You agree to indemnify and hold harmless MarryCenter.com and its affiliates from any claim, demand, or damage (including reasonable attorneys' fees) arising out of your use of the Website, your violation of these Terms, or your violation of any rights of another.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">12. Termination</h2>
                            <p className="mb-6">
                                We may suspend or terminate your account if you violate these Terms, our Privacy Policy, or Safety Guidelines. Where appropriate, we may provide notice or an opportunity to appeal before permanent termination.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">13. Governing Law and Dispute Resolution</h2>
                            <p className="mb-6">
                                These Terms shall be governed by and construed in accordance with the laws of Pakistan, without regard to its conflict of law provisions. Any dispute arising from these Terms shall be resolved through final and binding arbitration in Pakistan in accordance with the rules of the applicable local body. You waive your right to a class-action lawsuit.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">14. Changes to Terms</h2>
                            <p className="mb-6">
                                We reserve the right to modify these Terms at any time. We will notify you of changes by posting the new Terms on the Website. Your continued use of the Website after such changes constitutes your acceptance of the new Terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-3xl font-bold mb-6 text-gray-900">15. Contact Us</h2>
                            <p className="mb-4">If you have any questions about these Terms, please contact us at:</p>
                            <ul className="list-disc pl-8 space-y-3 mb-8">
                                <li>Email: <a href="mailto:shahidadmin@marrycenter.com" className="text-blue-600 hover:underline">shahidadmin@marrycenter.com</a></li>
                            </ul>
                        </section>


                    </div>
                </div>
            </div>

            {/* Simple Copyright Footer */}
            <div className="bg-gray-50 py-8 border-t border-gray-100 mt-auto">
                <div className="container mx-auto px-4 text-center text-gray-500 text-base">
                    &copy; 2026 MarryCenter. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default AppTermsPage;
